import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '35932428-2464-4112-a641-9c7a3c3eabfd',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '5dbda407-0c9c-466e-a55d-719d4814a549',
      type: 'Container',
      name: 'activeSlotContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '179dd41b-f369-4afa-af16-2400c9e01afe',
      type: 'Sprite',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: -257,
      y: -332,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_window',
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: 'd0d1b581-3766-4bb7-9760-c13780a84730',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 516,
      y: 39,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: 'ee08213e-d934-4002-a846-620eda775aa8',
      type: 'Sprite',
      name: 'confirmButton',
      nameSpace: '',
      className: '',
      x: 134,
      y: 561,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_button',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: 'f6b84740-2166-4c11-b29b-6bf1ed088d17',
      type: 'Sprite',
      name: 'leftArrow',
      nameSpace: '',
      className: '',
      x: 60,
      y: 578,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_arrow',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '63de071c-0f84-4988-8263-4ed8ad30ba26',
      type: 'Sprite',
      name: 'rightArrow',
      nameSpace: '',
      className: '',
      x: 442,
      y: 578,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_arrow',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '43c371fa-2e61-4608-be53-93aeebb37d21',
      type: 'Container',
      name: 'itemThumbnailContainer',
      nameSpace: '',
      className: '',
      x: 50,
      y: 105,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '67417dd4-6e5f-4c6f-85ba-667103cbb7ae',
      type: 'Sprite',
      name: 'scrollButton',
      nameSpace: '',
      className: '',
      x: 489,
      y: 86,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_scroll',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '6155832e-88d0-4d51-9971-5acbb33266df',
      type: 'Sprite',
      name: 'activeTab',
      nameSpace: '',
      className: '',
      x: 28,
      y: 20,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_tap',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '41445156-aa4c-4f2a-b21a-84f6f240c126',
      type: 'Sprite',
      name: 'tabIcon_0',
      nameSpace: '',
      className: '',
      x: 66,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_flower',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: 'b4c9c222-5887-4c77-8ea1-b675010bc8cc',
      type: 'Sprite',
      name: 'tabIcon_1',
      nameSpace: '',
      className: '',
      x: 141,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_tree',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '37a56877-5d7e-4f3c-9b5c-d5fa5effec95',
      type: 'Sprite',
      name: 'tabIcon_2',
      nameSpace: '',
      className: '',
      x: 216,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_hammer',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: 'aaf45dd4-7f38-46cd-b4e5-3ef11fc65692',
      type: 'Sprite',
      name: 'tabIcon_3',
      nameSpace: '',
      className: '',
      x: 291,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_wheelbarrow',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '02715a3a-6c46-4e29-a957-f17a862544f5',
      type: 'Sprite',
      name: 'tabIcon_4',
      nameSpace: '',
      className: '',
      x: 366,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_fence',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: 'b0422379-238b-429d-b7d4-1ae7559a6605',
      type: 'Sprite',
      name: 'tabIcon_5',
      nameSpace: '',
      className: '',
      x: 441,
      y: 54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_premium',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '683410c9-0b5f-492c-a24a-09d696239f4a',
      type: 'Container',
      name: 'catalogueContainer',
      nameSpace: '',
      className: '',
      x: 13,
      y: 83,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '04ef2432-8fa8-4391-9196-168d0b3a170c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 255,
      y: 545,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_line',
      parent: '179dd41b-f369-4afa-af16-2400c9e01afe',
      data: ''
    },
    {
      id: '7e7e0f98-5a33-43c4-a5dc-4587879c0d67',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 119,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Confirm',
      localize: true,
      maxWidth: 190,
      maxHeight: 60,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#187630',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 47,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ee08213e-d934-4002-a846-620eda775aa8',
      data: ''
    },
    {
      id: 'de502c78-0bd3-4dda-8313-74075874c8aa',
      type: 'Sprite',
      name: 'notification_0',
      nameSpace: '',
      className: '',
      x: 5,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: '41445156-aa4c-4f2a-b21a-84f6f240c126',
      data: ''
    },
    {
      id: '72d85791-74e4-4e7f-917b-6ec52b3371b2',
      type: 'Sprite',
      name: 'notification_1',
      nameSpace: '',
      className: '',
      x: 5,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: 'b4c9c222-5887-4c77-8ea1-b675010bc8cc',
      data: ''
    },
    {
      id: '7f4e17a0-f2c9-4314-9f9e-78ea50dbb32b',
      type: 'Sprite',
      name: 'notification_2',
      nameSpace: '',
      className: '',
      x: 5,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: '37a56877-5d7e-4f3c-9b5c-d5fa5effec95',
      data: ''
    },
    {
      id: '75039a5b-1111-490b-a12f-093970a55a6d',
      type: 'Sprite',
      name: 'notification_3',
      nameSpace: '',
      className: '',
      x: 5,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: 'aaf45dd4-7f38-46cd-b4e5-3ef11fc65692',
      data: ''
    },
    {
      id: '0081b8cc-772a-49c0-8a74-41b3327e68e9',
      type: 'Sprite',
      name: 'notification_4',
      nameSpace: '',
      className: '',
      x: 5,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: '02715a3a-6c46-4e29-a957-f17a862544f5',
      data: ''
    },
    {
      id: '2a52fc0f-ff4d-4f80-95b1-e946b133ce42',
      type: 'Sprite',
      name: 'notification_5',
      nameSpace: '',
      className: '',
      x: 5,
      y: -37,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.65,
        y: 0.65
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'notification',
      parent: 'b0422379-238b-429d-b7d4-1ae7559a6605',
      data: ''
    },
    {
      id: '9dab6120-72d2-416f-b20e-4f66ac5be014',
      type: 'Sprite',
      name: 'selectedItem',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_choose',
      parent: '683410c9-0b5f-492c-a24a-09d696239f4a',
      data: ''
    },
    {
      id: '7ec01694-4736-470b-84ec-a35be8dc8ddc',
      type: 'Container',
      name: 'scrollContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '683410c9-0b5f-492c-a24a-09d696239f4a',
      data: ''
    },
    {
      id: '38bbda11-7b06-4bcc-923e-7b1541ea3516',
      type: 'Sprite',
      name: 'selectedItemCheck',
      nameSpace: '',
      className: '',
      x: 17,
      y: 17,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'myfarm_shop_ui_check',
      parent: '9dab6120-72d2-416f-b20e-4f66ac5be014',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FarmCatalogueMenuLayout {
  static raw = raw;
  root: PIXI.Container
  activeSlotContainer: PIXI.Container
  bg: PIXI.Sprite
  closeButton: PIXI.Sprite
  confirmButton: PIXI.Sprite
  leftArrow: PIXI.Sprite
  rightArrow: PIXI.Sprite
  itemThumbnailContainer: PIXI.Container
  scrollButton: PIXI.Sprite
  activeTab: PIXI.Sprite
  tabIcon_0: PIXI.Sprite
  notification_0: PIXI.Sprite
  tabIcon_1: PIXI.Sprite
  notification_1: PIXI.Sprite
  tabIcon_2: PIXI.Sprite
  notification_2: PIXI.Sprite
  tabIcon_3: PIXI.Sprite
  notification_3: PIXI.Sprite
  tabIcon_4: PIXI.Sprite
  notification_4: PIXI.Sprite
  tabIcon_5: PIXI.Sprite
  notification_5: PIXI.Sprite
  catalogueContainer: PIXI.Container
  selectedItem: PIXI.Sprite
  selectedItemCheck: PIXI.Sprite
  scrollContainer: PIXI.Container

  constructor() {
    populate(this, raw);
  }
}
